module.exports = "<div class=\"form-component\">\r\n  <div class=\"fc-title\">\r\n  {{ \"PAYMENT_GATEWAY_REDIRECT\" | translate }}  \r\n  </div>\r\n  <button type=\"submit\" [class]=\"controlContext.style\">\r\n    {{ controlContext.paymentGatewayCode }}\r\n  </button>\r\n</div>\r\n  "


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/redirectPaymentGateway.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/flow-actions/redirectPaymentGateway.component.html
// module chunks = main